export const ROLE_IDs = {
    accountsManagementAndServicing: 5,
    analyst: 17,
    assistantVicePresident: 19,
    corporateFinancialExecutive: 3,
    groupSaleAndMarketingHead: 1,
    marketingAssistant: 6,
    marketingOfficer: 4,
    systemAdmin: 15,
    teamLeader: 2,
} as const;